import React, { forwardRef } from 'react';
import { cn } from '@/lib/utils';
interface AppInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  required?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  disabled?: boolean;
  hint?: string;
}
export const AppInput = forwardRef<HTMLInputElement, AppInputProps>(({
  label,
  error,
  helperText,
  required,
  leftIcon,
  rightIcon,
  disabled,
  hint,
  className = '',
  ...props
}, ref) => {
  return <div className={cn('flex flex-col gap-1.5', className)} data-id="element-49">
        {label && <label className="text-sm font-medium text-white/70" data-id="element-50">
            {label}
            {required && <span className="text-[#8eff01] ml-1" data-id="element-51">*</span>}
          </label>}
        <div className="relative" data-id="element-52">
          {leftIcon && <div className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40" data-id="element-53">
              {leftIcon}
            </div>}
          <input className={cn('w-full bg-white/[0.04] border border-white/[0.08] rounded-xl text-white placeholder:text-white/30', 'px-4 py-2.5 text-sm', 'focus:outline-none focus:border-[#8eff01]/40 focus:bg-white/[0.06] transition-all duration-200', leftIcon && 'pl-10', rightIcon && 'pr-10', error && 'border-red-500/40 focus:border-red-500/60', disabled && 'opacity-50 cursor-not-allowed')} disabled={disabled} {...props} data-id="element-54" />
          {rightIcon && <div className="absolute right-3 top-1/2 -translate-y-1/2 text-white/40" data-id="element-55">
              {rightIcon}
            </div>}
        </div>
        {error && <p className="text-xs text-red-400" data-id="element-56">{error}</p>}
        {hint && !error && <p className="text-xs text-white/40" data-id="element-57">{hint}</p>}
      </div>;
});
AppInput.displayName = 'AppInput';